import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { QRCodeCanvas } from "qrcode.react";
import { Tooltip } from "react-leaflet";
import CountUp from "../components/countUp";
import "./home.css";
import IndiaMap from "./PanIndiaMap";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
import bgImage from "../../src/public/assets/img/Home-Page-Parallax.jpg";
import { RxLetterCaseCapitalize } from "react-icons/rx";


import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";


const locations = [
  { name: "USA", coords: [37.0902, -95.7129] },
  { name: "Bahrain", coords: [26.0667, 50.5577] },
  { name: "Canada", coords: [56.1304, -106.3468] },
  { name: "UK", coords: [55.3781, -3.4360] },
  { name: "UAE", coords: [23.4241, 53.8478] },
  { name: "Australia", coords: [-25.2744, 133.7751] },
  { name: "Malaysia", coords: [4.2105, 101.9758] },
  { name: "Singapore", coords: [1.3521, 103.8198] },
  { name: "South Africa", coords: [-30.5595, 22.9375] },
  { name: "New Zealand", coords: [-40.9006, 174.8860] },
  { name: "France", coords: [46.2276, 2.2137] },
  { name: "Oman", coords: [21.4735, 55.9754] },
  { name: "Portugal", coords: [39.3999, -8.2245] }
];

const indiaCenter = [20.5937, 78.9629];
// default marker
const defaultIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png"
});

// active (hover) marker
const activeIcon = new L.Icon({
  iconUrl: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png"
});


const Home = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [about_data, setAboutData] = useState({});
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sliders, setSliders] = useState([]);
  const [homeProducts, setHomeProducts] = useState([]);
  const [featureProducts, setFeatureProducts] = useState([]);
  const whatsappNumber = "919662917174";

  const [activeCountry, setActiveCountry] = useState(null);
  const mapRef = useRef(null);
  const markerRefs = useRef({});

  // Data for the new Values section
  const values = [
    {
      title: "Timely Service",
      desc: "A product is only valuable to the consumer if they can use it on time. We ensure our patrons access products.",
      icon: "assets/logos/icon2.png",
      color: "#000000"
    },
    {
      title: "Transparent Policy",
      desc: "We understand the importance of transparency and accountability to build long-term relationships.",
      icon: "/assets/logos/icon3.png",
      color: "#000000"
    },

    {
      title: "Customer Satisfaction",
      desc: "All our actions are based on our customers’ needs. We strive to ensure 100% satisfaction.",
      icon: "/assets/logos/icon4.png",
      color: "#000000"
    },
  ];

  const handleSelect = (loc) => {
    setActiveCountry(loc.name);
    if (mapRef.current) {
      mapRef.current.flyTo(loc.coords, 5);
    }
    setTimeout(() => {
      markerRefs.current[loc.name]?.openPopup();
    }, 400);
  };

  const fetchCategories = () => {
    axios.post(`${BASE_URL}/api/category/get`).then((res) => {
      if (res.data.category.length > 0) setCategories(res.data.category);
    });
  };

  const fetchProducts = () => {
    axios.post(`${BASE_URL}/api/product/get`).then((res) => {
      if (res.data.product.length > 0) setProducts(res.data.product);
    });
  };

  useEffect(() => {
    fetchProducts();
    fetchHomeProducts();
    fetchFeatureProducts();
    // fetchSliders();
    fetchAbouts();
    fetchCategories();
  }, []);

  const fetchAbouts = async () => {
    const response = await axios.post(`${BASE_URL}/api/about/get`);
    setAboutData(response.data.about);
  };

  // const fetchSliders = () => {
  //   axios.post(`${BASE_URL}/api/slider/get`).then((res) => {
  //     if (res.data.slider.length > 0) setSliders(res.data.slider);
  //   });
  // };

  const fetchHomeProducts = () => {
    axios.post(`${BASE_URL}/api/category/get`).then((res) => {
      if (res.data.category.length > 0) setHomeProducts(res.data.category);
    });
  };

  const fetchFeatureProducts = () => {
    axios.post(`${BASE_URL}/api/product/getFeature`).then((res) => {
      if (res.data.product.length > 0) setFeatureProducts(res.data.product);
    });
  };

  const getPlainText = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <>
      <main className="main-content">
        {/* <section className="home-slider-area slider-default">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            loop={true}
            className="mySwiper"
          >
            {sliders.length > 0
              ? sliders.map((item, index) => {
                const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Hello! I'm interested in ${encodeURIComponent(
                  item.name,
                )}`;
                return (
                  <SwiperSlide>
                    <div
                      className="home-slider-item"
                      style={{
                        backgroundImage: `url(https://sachiproduct-backend.theaditech.in/${item.image})`,
                      }}
                    >
                     
                    </div>
                  </SwiperSlide>
                );
              })
              : ""}
          </Swiper>
        </section> */}
        <section className="home-slider-area slider-default">
  <Swiper
    modules={[Pagination, Autoplay]}
    spaceBetween={0}
    slidesPerView={1}
    autoplay={{
      delay: 3000,
      disableOnInteraction: false,
    }}
    pagination={{ clickable: true }}
    loop={true}
    className="mySwiper"
  >
    {/* Slide 1 */}
    <SwiperSlide>
      <div className="home-slider-item">
        <img
          alt="Slider 1 Desktop"
          src="/assets/img/slider12.png"
          className="home-slider-desktop"
        />
        <img 
          src="/assets/img/mobile1.png" 
          alt="Slider 1 Mobile" 
          className="home-slider-mobile" 
        />
      </div>
    </SwiperSlide>

    {/* Slide 2 */}
    <SwiperSlide>
      <div className="home-slider-item">
        <img
          src="/assets/img/slider4.png"
          alt="Slider 2 Desktop"
          className="home-slider-desktop"
        />
        <img 
          src="/assets/img/mobile4.png" 
          alt="Slider 2 Mobile" 
          className="home-slider-mobile" 
        />
      </div>
    </SwiperSlide>

    {/* Slide 3 */}
    <SwiperSlide>
      <div className="home-slider-item">
        <img
          src="/assets/img/slider3.png"
          alt="Slider 3 Desktop"
          className="home-slider-desktop"
        />
        <img 
          src="/assets/img/mobile3.png" 
          alt="Slider 3 Mobile" 
          className="home-slider-mobile" 
        />
      </div>
    </SwiperSlide>
      <SwiperSlide>
      <div className="home-slider-item">
        <img
          src="/assets/img/slider2.png"
          alt="Slider 3 Desktop"
          className="home-slider-desktop"
        />
        <img 
          src="/assets/img/mobile2.png" 
          alt="Slider 3 Mobile" 
          className="home-slider-mobile" 
        />
      </div>
    </SwiperSlide>
  </Swiper>
</section>
        <section className="about-home-area about-default-area slider-about">
          <div className="row">
            {/* Left Side: Content */}
            <div className="col-lg-7 col-md-12">
              <div className="about-content">
                {/* Title Section - Removed m-auto and text-center */}
                <div className="row">

                  <div className="col-lg-12">
                    <div
                      className="section-title"
                      style={{ textAlign: "left" }}
                    >
                      <span className="subtitle" style={{ display: "block" }}>
                        Welcome to
                      </span>
                      <h2 className="title">Sachi Products</h2>
                      <div
                        className="title-separator"
                        style={{ margin: "0" }}
                      ></div>
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    whiteSpace: "pre-line",
                    fontSize: "18px",
                    lineHeight: "1.6",
                    textAlign: "justify", // Makes text same size from both sides
                    marginTop: "20px",
                    paddingRight: "15px", // Optional: adds a bit of breathing room before the image
                  }}

                ><strong>Excellence in Hospitality Since 1996</strong><br />
                  Established in 1996, Sachi Products has grown into a trusted and distinguished name in the HoReCa (Hotels, Restaurants, and Catering) industry. For nearly three decades, we have been synonymous with quality, craftsmanship, and timeless elegance, serving hotels, restaurants, caterers, and corporate clients who value class, precision, and durability.

                  At Sachi, we believe that dining is more than just a service.it is an experience. The first impression begins at the table. From the placement of crockery to the balance of cutlery and the final presentation, every detail contributes to the story of hospitality. Our mission is to elevate that story through thoughtfully designed, high-performance products.

                </p>

                {/* Paragraph Section - Added textAlign justify and padding for balance */}
                {/* <p
                  style={{
                    whiteSpace: "pre-line",
                    fontSize: "18px",
                    lineHeight: "1.6",
                    textAlign: "justify", // Makes text same size from both sides
                    marginTop: "20px",
                    paddingRight: "15px", // Optional: adds a bit of breathing room before the image
                  }}
                >
                  {(() => {
                    const text = getPlainText(about_data?.description);
                    return text.length > 1000
                      ? `${text.substring(0, 1000)}...`
                      : text;
                  })()}
                </p> */}

                {/* Read More Button */}
                <Link to="/about" className="read-more-btn">
                  About Us <i className="fas fa-arrow-right ms-2"></i>
                </Link>
              </div>
            </div>

            {/* Right Side: Image/Video */}
            <div className="col-lg-5 col-md-12">
              <div className="video-button-container">
                <img
                  src="assets/img/sachi1.jpg"
                  alt="About Sachi Products"
                  className="img-fluid about-product"
                />

                {/* Video Play Button */}
                <a
                  href="https://www.instagram.com/reel/DUPrljhCQlj/?igsh=MWc3N3dnNmFqMDh6aw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-play-btn"
                >
                  <i className="fa fa-play"></i>
                  <span className="ripple"></span>
                </a>
              </div>
            </div>
          </div>
        </section>




        <section
          className="product-area latest-product-area"
          data-aos="fade-up"
          data-aos-duration="1000"
        // style={{ backgroundImage: "url('/assets/img/instagram-bg-image.jpg')" }}
        >
          <div className="container">


            <div className="row">
              <div className="col-lg-8 m-auto text-center">
                <div className="section-title">
                  <h2 className="title">Product Categories</h2>
                  <div className="title-separator"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="swiper-container product4-slider-container">
                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    // Essential for exact alignment
                    centeredSlides={false}
                    roundLengths={true}
                    watchSlidesProgress={true}
                    observer={true}
                    observeParents={true}
                    // Responsive Breakpoints
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 0, // No gap on mobile for 1-slide view
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      1024: {
                        slidesPerView: 4, // Exact 4 on desktop
                        spaceBetween: 30, // Adjust this based on your container width
                      },
                    }}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 2000, disableOnInteraction: false }}
                    loop={true}
                    className="myProductSwiperContent"
                  >
                    {homeProducts.map((product, index) => (
                      <SwiperSlide key={product.id || index}>
                        <div className="product-item">
                          <div className="product-thumb">
                            <Link to={`/product_by_category/${product.id}`}>
                              <img
                                src={`${BASE_URL}/${product.image}`}
                                alt={product.name}
                                className="product-img"
                              />
                            </Link>
                            <div className="product-action">
                              <Link
                                className="action-quick-view"
                                to={`/product_by_category/${product.id}`}
                                title="Quick View"
                              >
                                <i className="fa fa-opencart"></i>
                              </Link>
                            </div>
                          </div>
                          <div className="product-info">
                            <h4 className="title">
                              <Link to={`/product_by_category/${product.id}`}>
                                {product.name}
                              </Link>
                            </h4>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="values-section section-space" data-aos="fade-up">
          <div className="container">
            <div className="premium-header-container">
              <div className="premium-title-wrapper">
                <h2 className="premium-main-title">OUR <span>VALUES</span></h2>
              </div>
            </div>

            <div className="infographic-wrapper">
              {values.slice(0, 3).map((item, index) => (
                <div className={`capsule-item ${index % 2 !== 0 ? 'reverse' : ''}`} key={index}>
                  {/* The Connecting Path Line */}
                  {index < 2 && <div className={`path-line path-${index}`}></div>}

                  <div className="capsule-content" style={{ '--theme-color': item.color }}>
                    <div className="capsule-top">
                      <span className="chapter-text">0{index + 1}</span>
                      <h4 className="value-title">{item.title}</h4>
                      <p className="value-text-small">{item.desc}</p>
                    </div>
                    <div className="capsule-bottom">
                      <div className="icon-circle">
                        <img src={item.icon} alt={item.title} />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <div className="premium-header-container">
              <div className="premium-title-wrapper mb-4">
                <h2 className="premium-main-title">PAN <span>India</span></h2>
              </div>
            </div> */}
        <IndiaMap />

        <section>
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="section-title">
                <h2 className="title">Global Network</h2>
                <div className="title-separator"></div>
              </div>
            </div>
          </div>


          <div style={{ display: "flex", gap: "20px", height: "600px" }}>

            {/* LEFT LIST */}
            {/* <div style={{ width: "250px", overflowY: "auto" }}>
               <h3>Our Presence</h3> 

              {locations.map((loc, i) => (
                <div
                  key={i}
                  onClick={() => handleSelect(loc)}
                  onMouseEnter={() => setActiveCountry(loc.name)}
                  onMouseLeave={() => setActiveCountry(null)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "10px",
                    marginBottom: "8px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    background:
                      activeCountry === loc.name ? "#007bff" : "#f5f5f5",
                    color:
                      activeCountry === loc.name ? "#fff" : "#000",
                    transition: "0.3s"
                  }}
                >
                  📍 {loc.name}
                </div>
              ))}
            </div> */}

            {/* MAP */}
            <MapContainer
              center={[20, 0]}
              zoom={2}
              style={{ height: "100%", width: "100%" }}
              whenCreated={(map) => (mapRef.current = map)}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              {locations.map((loc, i) => (
                <Marker
                  key={i}
                  position={loc.coords}
                  icon={activeCountry === loc.name ? activeIcon : defaultIcon}
                  ref={(ref) => (markerRefs.current[loc.name] = ref)}
                  eventHandlers={{
                    mouseover: () => setActiveCountry(loc.name),
                    mouseout: () => setActiveCountry(null)
                  }}
                >

                  {/* Always visible name */}
                  <Tooltip direction="top" offset={[0, -10]} permanent>
                    {loc.name}
                  </Tooltip>
                  <Popup>
                    <b>{loc.name}</b><br />
                    Our Store Location
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>

        </section>


        <section className="instagram-area section-space">
          <div className="container">
            <div className="row">


              <div
                className="col-lg-10 m-auto"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {/* Section Title */}
                <div className="section-title text-center mb-5">
                  <h2 className="social-title">Follow Us on Social Media</h2>
                  <p className="social-subtitle">@sachiproducts</p>
                  <div className="title-separator"></div>
                </div>

                {/* Social Icons */}
                <div className="social-links-wrapper">
                  <div className="social-icons">
                    <a
                      href="https://www.instagram.com/sachiproducts1996/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram social-icon instagram"></i>
                    </a>

                    <a
                      href="https://www.facebook.com/sachiproducts1996"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f social-icon facebook"></i>
                    </a>

                    <a
                      href="https://www.youtube.com/@SACHIPRODUCTS"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube social-icon youtube"></i>
                    </a>

                    <a
                      href="https://share.google/qaC1i1FUSDpiC1VJ4"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-google social-icon google"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="quality-section section-space"
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <div className="quality-overlay"></div>

          <div className="container quality-container">
            <div className="row align-items-center">
              {/* LEFT SIDE TEXT */}
              <div className="col-lg-5 col-md-12 mb-5 mb-lg-0">
                <div className="quality-content" data-aos="fade-right">
                  <h6 className="sub-title">A Brand You Can Trust Upon</h6>
                  <h2 className="main-title">
                    Serving Best Quality Products{" "}
                    <span className="gold-text">Since 1996</span>
                  </h2>
                  <p className="description">
                    Over three decades of excellence in delivering premium
                    tableware and lifestyle products to our global patrons.
                  </p>
                  <Link to="/product" className="buy-now-btn">
                    View Our Products <i className="fas fa-arrow-right ms-2"></i>
                  </Link>
                </div>
              </div>

              {/* RIGHT SIDE STATS */}
              <div className="col-lg-7 col-md-12">
                <div className="stats-grid-wrapper" data-aos="fade-left">
                  <div className="stats-grid">
                    {[
                      { number: 1996, label: "Founding Year", suffix: "" },
                      { number: 15000, label: "Happy Clients", suffix: "+" },
                      { number: 8000, label: "Products", suffix: "+" },
                      { number: 30, label: "Years Success", suffix: "+" },
                      { number: 25, label: "Team Members", suffix: "+" },
                      { number: 2, label: "Outlets", suffix: "" },
                    ].map((item, index) => (
                      <div key={index} className="stat-card">
                        <h3 className="stat-number">
                          <CountUp end={item.number} duration={3} />
                          {item.suffix}
                        </h3>
                        <p className="stat-label">{item.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
export default Home;
